import { action, makeAutoObservable, observable } from "mobx"

import masterDataService from "@services/master-data/masterDataService"
import propertyTypeService from "@services/master-data/propertyTypeService"
import cartService from "@services/cart/cartService"

class MasterDataStore {
  @observable isLoading!: boolean

  @observable employees!: any[]
  @observable listPropertyType: any = []
  @observable listCart: any = []

  constructor() {
    makeAutoObservable(this)

    this.employees = []
  }

  @action
  async getListPropertyType(params?: any) {
    this.isLoading = true
    const result = await propertyTypeService
      .getListForAdmin(params)
      .finally(() => (this.isLoading = false))
    this.listPropertyType = result
  }
  @action
  async getListCart(params?: any) {
    this.isLoading = true
    const result = await cartService
      .getListForAdmin(params)
      .finally(() => (this.isLoading = false))
    this.listCart = result
  }

  @action
  async filterEmployees(params: any) {
    params.skipCount = params.skipCount || 0
    params.maxResultCount = params.maxResultCount || 20
    params.isActive = true
    this.isLoading = true

    this.employees = await masterDataService
      .filterEmployees(params)
      .finally(() => (this.isLoading = false))
  }
}

export default MasterDataStore
